import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top of page when route changes
    window.scrollTo(0, 0);
    
    // Track page view whenever route changes
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageTracker;
